import {
  Alert,
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import { useTranslation } from "react-i18next";

import { useAddTreuhaenderMutation } from "store/masterdata";
import { AddTHParams } from "types/masterdata.types";

interface Props {
  treuhandstelleId: number;
  visible: boolean;
  onClose(): void;
  onSuccess(): void;
}

function CreateNewTHForm({
  treuhandstelleId,
  visible,
  onClose,
  onSuccess,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const [tHForm] = Form.useForm();

  const [addTH, addTHResult] = useAddTreuhaenderMutation();

  const handleTHFormSubmit = async (values: AddTHParams) => {
    try {
      const repsonse = await addTH({ ...values, treuhandstelleId }).unwrap();
      if (!repsonse?.hasErrors) {
        notification.success({
          message: t("masterdata.lw_details.add_th_success"),
        });
        onSuccess();
        onClose();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const langOptions = [0, 1, 2].map((option) => ({
    label: t(`masterdata.enums.LanguageEnum.${option}`),
    value: option,
  }));

  return (
    <Modal
      footer={null}
      title={t("masterdata.lw_details.create_new_th")}
      visible={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="th-form"
        form={tHForm}
        onFinish={handleTHFormSubmit}
        layout="vertical"
        initialValues={{
          firstname: "",
          lastname: "",
          email: "",
          address: "",
          postalCode: "",
          place: "",
          primaryPhone: "",
        }}
      >
        {addTHResult.data?.hasErrors && (
          <>
            <Alert
              message={addTHResult.data?.errorDetails.errorMessage}
              type="error"
            />
            <Divider />
          </>
        )}
        <Form.Item
          label={t("masterdata.lw_details.firstname")}
          name="firstname"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.lastname")}
          name="lastname"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.adresse")}
          name="address"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.postal_code")}
          name="postalCode"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.ort")}
          name="place"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.email")}
          name="email"
          rules={[{ required: true, type: "email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.phone")}
          name="primaryPhone"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.language")}
          name="language"
          rules={[{ required: true }]}
        >
          <Select options={langOptions} />
        </Form.Item>
        <Row gutter={20}>
          <Col span={12}>
            <Button onClick={onClose} block>
              {t("discard")}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              loading={addTHResult.isLoading}
              block
            >
              {t("save_changes")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default CreateNewTHForm;
